import { washLanguageData, washShareData, washText } from '@/utils/wash.js'
import { types } from './element.js'
const washData = (node) => {
  try {
    switch (node._type) {
      case types.one:
        const flags = ['inquire-now', 'next-product']
        for (let v of flags) {
          washLanguageData(node, v, undefined, types.one)
        }
        break
      case types.two:
        const flags2 = ['inquire-now', 'next-product', 'downloadSingle']
        for (let v of flags2) {
          washLanguageData(node, v, undefined, types.two)
        }
        break
    }
    washShareData(node, 'share', 'name')
    washText(node)
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
